import { WorkPolicyFormErrors, WorkPolicyFormValue } from "./hooks/use-work-policy-form";
import { calendarMonthRangeInputBounds } from "../work-type-shared/calendar-date-range";
import { ErrorText, Field, FormGrid, FormSection } from "./work-type-management.styles";

interface BasePolicySectionProps {
  value: WorkPolicyFormValue;
  errors: WorkPolicyFormErrors;
  onChange: <K extends keyof WorkPolicyFormValue>(
    field: K,
    value: WorkPolicyFormValue[K]
  ) => void;
  readOnly?: boolean;
}

export const BasePolicySection = ({ value, errors, onChange, readOnly = false }: BasePolicySectionProps) => {
  const rangeBounds = calendarMonthRangeInputBounds(
    value.effectiveStartDate,
    value.effectiveEndDate
  );
  return (
    <FormSection>
      <legend>기본 정책 적용 설정</legend>
      <p>환경설정의 적용기간에 따라 미래 예정 근무 데이터가 생성됩니다.</p>
      <FormGrid>
        <Field>
          적용 시작일
          <input
            id="work-policy-effectiveStartDate"
            type="date"
            value={value.effectiveStartDate}
            disabled={readOnly}
            min={rangeBounds.startMin}
            aria-invalid={Boolean(errors.effectiveStartDate)}
            aria-describedby={errors.effectiveStartDate ? "work-policy-effectiveStartDate-error" : undefined}
            onChange={event => {
              const next = event.currentTarget.value;
              onChange("effectiveStartDate", next);
              if (!value.settlementPreviewDate) onChange("settlementPreviewDate", next);
            }}
          />
          {errors.effectiveStartDate && <ErrorText id="work-policy-effectiveStartDate-error">{errors.effectiveStartDate}</ErrorText>}
        </Field>
        <Field>
          적용 종료일
          <input
            id="work-policy-effectiveEndDate"
            type="date"
            value={value.effectiveEndDate}
            disabled={readOnly}
            min={value.effectiveStartDate || undefined}
            max={rangeBounds.endMax}
            aria-invalid={Boolean(errors.effectiveEndDate)}
            aria-describedby={errors.effectiveEndDate ? "work-policy-effectiveEndDate-error" : undefined}
            onChange={event => onChange("effectiveEndDate", event.currentTarget.value)}
          />
          {errors.effectiveEndDate && <ErrorText id="work-policy-effectiveEndDate-error">{errors.effectiveEndDate}</ErrorText>}
        </Field>
      </FormGrid>
      <p>
        저장하면 위 기간의 미래 예정 데이터만 재생성 대상이 됩니다. 이미 확정된 과거 실적은
        변경하지 않습니다. 저장 전 확인 창에서 정책명과 대상 기간을 다시 확인합니다.
      </p>
    </FormSection>
  );
};
